<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="Danger-Triangle--Streamline-Solar-Broken" height="24" width="24">
    <desc>
      Danger Triangle Streamline Icon: https://streamlinehq.com
    </desc>
    <!-- eslint-disable-next-line max-len -->
    <path d="M6.30928 9C8.59494 5 9.96832 3 12 3c2.3107 0 3.7699 2.58716 6.6883 7.7615l0.3636 0.6448c2.4252 4.2998 3.6378 6.4497 2.5418 8.0217C20.4978 21 17.7864 21 12.3637 21h-0.7274c-5.42274 0 -8.13413 0 -9.23004 -1.572 -0.95128 -1.3645 -0.1632 -3.1645 1.64747 -6.428"
      stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"></path>
    <path d="M12 8v5" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"></path>
    <path fill="#FFFFFF" d="M11 16a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" stroke-width="1.5"></path>
  </svg>
</template>

<script>
export default {
  name: 'DangerTriangle',
};
</script>
